export default "__VITE_ASSET__COI2AKt3__"